// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__90UYT","logo":"navbar_logo__bKPrp","navText":"navbar_navText__7-at0"};